var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_vm._t("bar-nav-icon")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }